(() => {
  if (window.WSCollectionCardStateReady) return;
  window.WSCollectionCardStateReady = true;
  const selector = '[data-card-cart-product-id]';
  let products = new Set(), confirmedAdds = new Set(), known = false, revision = 0, pending, queued = false;
  const paint = () => {
    document.querySelectorAll(selector).forEach(button => {
      const id = String(button.dataset.cardCartProductId);
      if (!known && !confirmedAdds.has(id)) return;
      const active = products.has(id) || confirmedAdds.has(id);
      button.dataset.inCart = String(active);
      button.dataset.cartOriginalLabel ||= button.getAttribute('aria-label') || '';
      const label = active
        ? button.dataset.cartOriginalLabel + ' — ' + button.dataset.cardCartActiveLabel
        : button.dataset.cartOriginalLabel;
      button.setAttribute('aria-label', label);
    });
  };
  const accept = cart => {
    if (!Array.isArray(cart?.items)) return;
    revision += 1;
    products = new Set(cart.items.filter(item => item.quantity > 0).map(item => String(item.product_id)));
    confirmedAdds.clear();
    known = true;
    paint();
  };
  const refresh = () => {
    revision += 1;
    if (!document.querySelector(selector)) return pending;
    if (pending) { queued = true; return pending; }
    const started = revision;
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 10000);
    pending = fetch((window.Shopify?.routes?.root || '/') + 'cart.js', {
      headers: { Accept: 'application/json' }, cache: 'no-store', signal: controller.signal
    }).then(response => {
      if (!response.ok) throw new Error('cart-state');
      return response.json();
    }).then(cart => {
      if (started === revision) accept(cart);
    }).catch(() => { /* Keep the last confirmed state; never infer an empty cart from a failed read. */ })
      .finally(() => {
        clearTimeout(timeout); pending = null;
        if (queued) { queued = false; refresh(); }
      });
    return pending;
  };
  // Drawer section requests can resolve out of order. Treat their events as
  // invalidation signals, and read an authoritative snapshot ourselves.
  document.addEventListener('ws:cart-rendered', refresh);
  document.addEventListener('ws:card-add-confirmed', event => {
    const id = event.detail?.productId;
    if (!id) return;
    confirmedAdds.add(String(id));
    paint();
    refresh();
  });
  document.addEventListener('wundersaam:collection-updated', () => { paint(); refresh(); });
  document.addEventListener('shopify:section:load', () => { paint(); refresh(); });
  window.addEventListener('pageshow', event => { if (event.persisted) refresh(); });
  window.addEventListener('focus', refresh);
  document.addEventListener('visibilitychange', () => { if (!document.hidden) refresh(); });
  refresh();
})();
